import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@zlib/services/auth.service';
import { SecurityHelper } from '@zlib/services/security.helper';

@Injectable()
export class PermissionGuard  {
    constructor(private router: Router, private authService: AuthService, private securityHelper: SecurityHelper) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const permissions: string[] = route.data.permissions;
        try {
            if (!this.authService.isAuthenticated()) {
                this.authService.logout();
                this.router.navigate(['/auth/login']);
                return false;
            }

            if (!permissions || permissions.length === 0) {
                return true;
            }

            if (!this.securityHelper.hasOneOfPermissions(permissions)) {
                this.router.navigate(['/error/not-permission']);
                return false;
            }
            return true;
        } catch (err) {
            this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }
}
